/**
 * v4 icon-box color resolver (DESIGN_SYSTEM.md sections 8.2 / 8.4 / 9.3).
 *
 * Maps a semantic category to its background + accent glyph color, read entirely
 * from the MUI theme (theme.palette.tint.* / cat.* / semantic slots). Never
 * returns a hardcoded hex. Shared by Row and MetricPill.
 *
 * v4 (#1377): both themes paint the pre-baked palette.tint.* fills directly.
 * The light theme's tint tokens are already deepened for the cool-gray surface
 * (tokens/colors-light.css), so the old #1117 alpha(accent, 0.2) light-mode
 * override is retired. `neutral` gains a real tint token (previously the hover
 * overlay), and `planned` maps to the interactive accent (Planned Expenses).
 *
 * @param {object} theme   MUI theme (from useTheme())
 * @param {string} category  one of checking|credit|savings|budgets|income|
 *                            planned|neutral|positive|negative|warning|interactive
 * @returns {{ tint: string, accent: string }}
 */
export const iconBoxColors = (theme, category) => {
  const { palette } = theme;
  const map = {
    checking:    { tint: palette.tint.checking,    accent: palette.cat.checking },
    credit:      { tint: palette.tint.credit,      accent: palette.cat.credit },
    savings:     { tint: palette.tint.savings,     accent: palette.cat.savings },
    budgets:     { tint: palette.tint.budgets,     accent: palette.cat.budgets },
    income:      { tint: palette.tint.income,      accent: palette.cat.income },
    neutral:     { tint: palette.tint.neutral,     accent: palette.cat.neutral },
    planned:     { tint: palette.tint.interactive, accent: palette.interactive },
    positive:    { tint: palette.tint.positive,    accent: palette.success.main },
    negative:    { tint: palette.tint.negative,    accent: palette.error.main },
    warning:     { tint: palette.tint.warning,     accent: palette.warning.main },
    interactive: { tint: palette.tint.interactive, accent: palette.interactive },
  };
  return map[category] || map.neutral;
};

/** Category accent dot color (section headers, DESIGN_SYSTEM.md section 8.1). */
export const categoryDotColor = (theme, category) =>
  iconBoxColors(theme, category).accent;
